import React from 'react';
import { Grid } from '@material-ui/core';

import PrompterModeAction from './PrompterModeAction';
import CameraModeAction from './CameraModeAction';
import { StudioControlStyles } from '../styles';
import {detectIOS } from '../../../utility/helpers';

const MainStudioActions = () => {
  const classes = StudioControlStyles();

  return (
    <Grid
      item
      container
      className={classes.commonStudioAction}
      alignItems="flex-start"
      alignContent="flex-start"
      justify="flex-start"
    >
      <PrompterModeAction />
      {( detectIOS() ? null :
          (
            <CameraModeAction />
          )
      )}
    </Grid>
  );
};

export default MainStudioActions;
